export const LOGIN_API = '/api/security/login'
export const REGISTER_API = '/api/security/register'
export const REGISTER_CONFIRM_API = '/api/security/register/confirm'
export const RESTORE_PASSWORD_API = '/api/security/send-reset'
export const RESET_PASSWORD_API = '/api/security/reset'
export const TWO_FACTOR_AUTHENTICATION_API = '/2fa_check'
export const GET_CAPTCHA_API = '/api/security/captcha'
